function Yosh({imgsrc}){
    return(
        <div>
            <h2>Hi Yosh!</h2>
            <img alt="camera" style={{maxWidth:"80%", display: "block", margin:"0 auto", padding: 0}} src={imgsrc}/>
            <p>Thanks for always being there for Patti!</p>
        </div>
    )
}
export default Yosh